// Import model
import { CheckboxFieldOptions } from '../models/CheckboxFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CheckboxFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class CheckboxFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a CheckboxFieldOptions instance
   */
  static deserialize(json: string): CheckboxFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CheckboxFieldOptions instance
   */
  static fromObject(obj: any): CheckboxFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CheckboxFieldOptions');
    }


    const instance: CheckboxFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      style: obj['Style'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CheckboxFieldOptions instances
   */
  static deserializeArray(json: string): CheckboxFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CheckboxFieldOptions instance to a JSON string
   */
  static serialize(instance: CheckboxFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CheckboxFieldOptions instance to a plain object
   */
  static toObject(instance: CheckboxFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Style': instance.style,
    };
  }

  /**
   * Serializes an array of CheckboxFieldOptions instances to a JSON string
   */
  static serializeArray(instances: CheckboxFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
